(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["legal-guarantee-notice"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', (event) => {
    if (
      event.key === ' ' &&
      event.target.matches('.swg-legal-notice > [data-js-title]')
    ) {
      event.preventDefault();
      event.target.click();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-option-dropdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('swg-variant-dropdown')) {
  class SwgVariantDropdown extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) this.setup();
      });
    }

    disconnectedCallback() {
      this._controller?.abort();
      this._observer?.disconnect();
      this._controller = null;
      if (this._select) this._select.hidden = false;
      if (this._menu) this._menu.hidden = true;
      this.removeAttribute('data-enhanced');
    }

    setup() {
      if (this._controller) return;
      this._select = this.querySelector('select');
      this._menu = this.querySelector('[data-swg-menu]');
      this._summary = this.querySelector('summary');
      this._selection = this.querySelector('[data-swg-selection]');
      this._buttons = [...this.querySelectorAll('[data-swg-option-id]')];
      if (!this._select || !this._menu || !this._summary || !this._selection) return;

      this._controller = new AbortController();
      const signal = this._controller.signal;

      this.addEventListener('click', event => {
        const button = event.target.closest('[data-swg-option-id]');
        if (button && this.contains(button)) {
          event.preventDefault();
          this.choose(button);
        } else if (event.target.closest('summary') === this._summary && !this._hasChoices) {
          event.preventDefault();
        }
      }, { signal });

      this.addEventListener('keydown', event => this.onKeydown(event), { signal });
      this._select.addEventListener('change', () => this.refresh(), { signal });

      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.close(false);
      }, { signal });

      document.addEventListener('focusin', event => {
        if (!this.contains(event.target)) this.close(false);
      }, { signal });

      this._menu.addEventListener('toggle', () => {
        if (!this._menu.open) return;
        document.querySelectorAll('swg-variant-dropdown').forEach(dropdown => {
          if (dropdown !== this && typeof dropdown.close === 'function') dropdown.close(false);
        });
      }, { signal });

      this._observer = new MutationObserver(() => this.refresh());
      this._observer.observe(this._select, {
        attributes: true,
        childList: true,
        subtree: true
      });

      this.refresh();
      this._menu.hidden = false;
      this._select.hidden = true;
      this.setAttribute('data-enhanced', '');
    }

    refresh() {
      const options = new Map([...this._select.options].map(option => [
        option.dataset.optionValueId, option
      ]));
      const mode = this.dataset.unavailableMode;
      const selected = this._select.selectedOptions[0];

      this._buttons.forEach(button => {
        const option = options.get(button.dataset.swgOptionId);
        const unavailable = option?.dataset.available === 'false' && !option.hasAttribute('data-product-url');
        button.hidden = !option || option.hidden || option.style.display === 'none' ||
          (mode === 'hide' && unavailable);
        button.disabled = !option || this._select.disabled || option.disabled ||
          ((mode === 'disable' || mode === 'hide') && unavailable);
        button.setAttribute('aria-pressed', option?.selected ? 'true' : 'false');
      });

      const selectedButton = this._buttons.find(button =>
        button.dataset.swgOptionId === selected?.dataset.optionValueId
      );
      const content = selectedButton?.querySelector('[data-swg-option-content]');
      if (content) {
        this._selection.replaceChildren(content.cloneNode(true));
      } else {
        this._selection.textContent = selected?.textContent.trim() || '';
      }

      this._hasChoices = this.enabledButtons().length > 0;
      this._summary.setAttribute('aria-disabled', this._hasChoices ? 'false' : 'true');
      if (!this._hasChoices) this.close(false);
    }

    enabledButtons() {
      return this._buttons.filter(button => !button.hidden && !button.disabled);
    }

    choose(button) {
      this.refresh();
      if (button.disabled || button.hidden) return;
      const option = [...this._select.options].find(option =>
        option.dataset.optionValueId === button.dataset.swgOptionId
      );
      if (!option) return;

      this._select.value = option.value;
      this._select.dispatchEvent(new Event('change', { bubbles: true }));
      this.refresh();
      this.close(true);
    }

    close(returnFocus) {
      if (!this._menu) return;
      this._menu.open = false;
      if (returnFocus && this.isConnected) this._summary.focus({ preventScroll: true });
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this._menu.open) {
        event.preventDefault();
        event.stopPropagation();
        this.close(true);
        return;
      }

      const keys = ['ArrowDown', 'ArrowUp', 'Home', 'End'];
      if (!keys.includes(event.key) || !this._hasChoices) return;
      if (!this._summary.contains(event.target) && !event.target.closest('[data-swg-option-id]')) return;

      event.preventDefault();
      const wasOpen = this._menu.open;
      this._menu.open = true;
      const buttons = this.enabledButtons();
      const currentIndex = buttons.indexOf(document.activeElement);
      let nextIndex;

      if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = buttons.length - 1;
      } else if (!wasOpen || currentIndex < 0) {
        nextIndex = event.key === 'ArrowUp' ? buttons.length - 1 : 0;
      } else {
        const direction = event.key === 'ArrowDown' ? 1 : -1;
        nextIndex = (currentIndex + direction + buttons.length) % buttons.length;
      }

      buttons[nextIndex]?.focus({ preventScroll: true });
      buttons[nextIndex]?.scrollIntoView({ block: 'nearest' });
    }
  }

  customElements.define('swg-variant-dropdown', SwgVariantDropdown);
}
  } catch(e) { console.error(e); }
})();

})();
